import React from "react";

export const MedicationSvg = ({pathNames}) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          clipPath="url(#a)"
          stroke={
            pathNames?.includes("/home/medication")
              ? "#ffffff"
              : "#667085"
          }
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 1.917a.25.25 0 1 0 .167-.25h-.834a1.667 1.667 0 0 0-1.666 1.666V7.5a5 5 0 0 0 10 0V3.333A1.667 1.667 0 0 0 10 1.667h-.833a.177.177 0 1 0 .25.25" />
          <path d="M6.667 12.5v.833a5 5 0 1 0 10 0V10" />
          <path d="M16.667 10a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333" />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h20v20H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
